module.exports = __webpack_public_path__ + "static/media/community-photo-black.710d3c5c.svg";